// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__yD5Uz","label":"Section_label__3Fq7-","contentWrap":"Section_contentWrap__3sz_8","footer":"Section_footer__2rEao","footerInner":"Section_footerInner__2WRgv"};